export async function downloadPdf(certEl, { slug, id }) {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
    import('html2canvas'),
    import('jspdf'),
  ]);
  if (document.fonts?.ready) await document.fonts.ready;
  const canvas = await html2canvas(certEl, { scale: 3, backgroundColor: null, useCORS: true });
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = 210;
  const pageHeight = 297;
  const margin = 16;
  const w = pageWidth - margin * 2;
  const h = (canvas.height / canvas.width) * w;
  const y = (pageHeight - h) / 2;
  pdf.addImage(imgData, 'PNG', margin, y, w, h);
  pdf.save(`gay-certification-${slug || id}.pdf`);
}
